const Loading = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-50">
      <div className="absolute bg-white opacity-50 w-full h-full"></div>
      <div className="bg-white w-10 h-10 flex items-center justify-center rounded-lg">
        <div className="relative w-8 h-8 border-4 border-dashed rounded-full border-indigo-600 animate-spin"></div>
      </div>
    </div>
  );
};

export default Loading;
